import { IAboutDetails } from '@/interfaces/IAboutUsData';
import styles from './WhatWeTreatText.module.css';
type props = {
    whatWeTreatText: IAboutDetails
}
export function WhatWeTreatText({ whatWeTreatText }: props) {
    return <section className={`${styles.whyChooseUs} ${styles.power_four_warp}`}>
        <div className="container">
            <h2 className="sectionHeading mb22">{whatWeTreatText.why_choose_nirvasa_title}</h2>
            <div className={styles.whyusBox}>
                {whatWeTreatText.why_choose_nirvasa_content.map((f, idx) =>
                    <div className={styles.whyusItem} key={idx}>
                        <figure className={`${styles.whyNumber} font16 mb10`}>{`${idx+1}`}</figure>
                        <h3 className="font16 font600 mb10 text46675">{f.title}</h3>
                        <p className="font16 fontThin text666">{f.content}</p>
                    </div>
                )}
            </div>
        </div>
    </section>
}